import React from 'react';
import ReactDOM from 'react-dom';
import { StoreProvider } from './store';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer } from 'react-toastify';
import dotenv from 'dotenv';

import App from './App';
import * as serviceWorker from './serviceWorker';

import './assets/styles/index.scss';

// Initialize dotenv module
dotenv.config();

const rootDiv = document.getElementById('root');

ReactDOM.render(
    <StoreProvider>
        <ToastContainer />
        <div id={'app-container'}>
            <App />
        </div>
    </StoreProvider>,
    rootDiv,
);

serviceWorker.unregister();
